import { render, staticRenderFns } from "./ReasonList.vue?vue&type=template&id=535648db"
import script from "./ReasonList.vue?vue&type=script&lang=js"
export * from "./ReasonList.vue?vue&type=script&lang=js"
import style0 from "./ReasonList.vue?vue&type=style&index=0&id=535648db&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports